import { createAsyncThunk } from '@reduxjs/toolkit'
import { SecurityIPAccessesServerData } from '@lk/api'

import { actions as LKActions } from '../../../features/shared/LKModal'
import { ThunkApi } from '../../index.d'

export const loadSecurityIPAccesses = createAsyncThunk<SecurityIPAccessesServerData, void, ThunkApi>(
  '[SECURITY] LOAD_SECURITY_IP_ACCESSES',
  async (_, { dispatch, extra, rejectWithValue }) => {
    const result = await extra.api.security.ipAccesses()

    if (result.success) {
      return result.data
    }

    dispatch(LKActions.openError(result.error.message))

    return rejectWithValue(result.error.message)
  },
)
